import { IPlanningFilterConfigurationSearchResult } from '../../../../../planningLevelConfiguration/components/planningFilterConfiguration/hooks/usePlanningFilterConfigurationSearch';
import { AnyHierarchyLevel, HierarchyType } from '../../types/hierarchies.type';

export interface IHierarchyFilter {
	children: AnyHierarchyLevel | null;
	father: AnyHierarchyLevel | null;
	self: AnyHierarchyLevel | null;
	planingSetupField: keyof IPlanningFilterConfigurationSearchResult;
}

export const hierarchyFilterByHierarchy: Record<
	HierarchyType,
	Partial<Record<AnyHierarchyLevel, IHierarchyFilter>> & {
		father: AnyHierarchyLevel;
	}
> = {
	customer: {
		customer_group: {
			father: null,
			self: AnyHierarchyLevel.CUSTOMER_GROUP,
			children: AnyHierarchyLevel.CUSTOMER,
			planingSetupField: 'has_customer_group',
		},
		customer: {
			father: AnyHierarchyLevel.CUSTOMER_GROUP,
			self: AnyHierarchyLevel.CUSTOMER,
			children: null,
			planingSetupField: 'has_customer',
		},
		father: AnyHierarchyLevel.CUSTOMER_GROUP,
	},
	commercial: {
		market: {
			father: null,
			self: AnyHierarchyLevel.MARKET,
			children: AnyHierarchyLevel.SALES_CHANNEL,
			planingSetupField: 'has_market',
		},
		sales_channel: {
			father: AnyHierarchyLevel.MARKET,
			self: AnyHierarchyLevel.SALES_CHANNEL,
			children: AnyHierarchyLevel.SALES_FORCE,
			planingSetupField: 'has_sales_channel',
		},
		sales_force: {
			father: AnyHierarchyLevel.SALES_CHANNEL,
			self: AnyHierarchyLevel.SALES_FORCE,
			children: AnyHierarchyLevel.SALES_ZONE,
			planingSetupField: 'has_sales_force',
		},
		sales_zone: {
			father: AnyHierarchyLevel.SALES_FORCE,
			self: AnyHierarchyLevel.SALES_ZONE,
			children: AnyHierarchyLevel.SELLER,
			planingSetupField: 'has_sales_zone',
		},
		seller: {
			father: AnyHierarchyLevel.SALES_ZONE,
			self: AnyHierarchyLevel.SELLER,
			children: null,
			planingSetupField: 'has_seller',
		},
		father: AnyHierarchyLevel.MARKET,
	},
	product: {
		family: {
			father: null,
			self: AnyHierarchyLevel.FAMILY,
			children: AnyHierarchyLevel.SUBFAMILY,
			planingSetupField: 'has_family',
		},
		subfamily: {
			father: AnyHierarchyLevel.FAMILY,
			self: AnyHierarchyLevel.SUBFAMILY,
			children: AnyHierarchyLevel.MODEL,
			planingSetupField: 'has_subfamily',
		},
		model: {
			father: AnyHierarchyLevel.SUBFAMILY,
			self: AnyHierarchyLevel.MODEL,
			children: AnyHierarchyLevel.PRODUCT,
			planingSetupField: 'has_model',
		},
		product: {
			father: AnyHierarchyLevel.MODEL,
			self: AnyHierarchyLevel.PRODUCT,
			children: null,
			planingSetupField: 'has_product',
		},
		father: AnyHierarchyLevel.FAMILY,
	},
};
interface IBuildHierarchyByLevelResult {
	hierarchyFilterMain: IHierarchyFilter | null | undefined;
	hierarchiesFilterMain: Partial<
		Record<AnyHierarchyLevel, IHierarchyFilter>
	> | null;
}
export const buildHierarchyByLevel = (
	planningFilterConfiguration?: IPlanningFilterConfigurationSearchResult
): IBuildHierarchyByLevelResult => {
	if (!planningFilterConfiguration)
		return {
			hierarchyFilterMain: null,
			hierarchiesFilterMain: null,
		};
	const hierarchyType = planningFilterConfiguration.main_filter;
	const hierarchyFilterComplete = hierarchyFilterByHierarchy[hierarchyType];
	const hierarchiesFilterMain: Partial<
		Record<AnyHierarchyLevel, IHierarchyFilter>
	> = {};
	let currentLevelComplete: AnyHierarchyLevel | null =
		hierarchyFilterComplete.father;
	let previousLevel: AnyHierarchyLevel | null = null;
	let currentLevel: AnyHierarchyLevel | null = null;
	let fatherLevel: AnyHierarchyLevel | null = null;

	while (currentLevelComplete) {
		const hierarchy = hierarchyFilterComplete[
			currentLevelComplete
		] as IHierarchyFilter;
		if (!hierarchy) break;

		const planingSetupField = hierarchy.planingSetupField;

		if (planningFilterConfiguration[planingSetupField] === true) {
			if (!fatherLevel) {
				fatherLevel = currentLevelComplete;
			}
			currentLevel = currentLevelComplete;
			hierarchiesFilterMain[currentLevel] = {
				...hierarchy,
				father: previousLevel,
				children: null,
			};
			const hierarchiesNext =
				hierarchiesFilterMain[
					previousLevel as unknown as AnyHierarchyLevel
				];
			if (previousLevel && hierarchiesNext) {
				hierarchiesNext.children = currentLevel;
			}
			previousLevel = currentLevel;
		}

		currentLevelComplete = hierarchy.children;
	}
	return {
		hierarchyFilterMain:
			hierarchiesFilterMain[fatherLevel as AnyHierarchyLevel],
		hierarchiesFilterMain,
	};
};
